import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  TextField,
  Switch,
  Typography,
  IconButton,
  Autocomplete,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import AutoCompleteMultiSelect from "../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx";
import jwt_decode from "jwt-decode";
import SweetAlertModal from "../components/SweetAlertModal/SweetAlertModal";
import { toast } from "react-toastify";

function AddRestaurantCreditDialog({ open, onClose, existingCredits, existingData, SetOpenEditModal }) {
  const [restaurantDatas, setRestaurantDatas] = useState([]);
  const [restaurantAdded, setRestaurantAdded] = useState([]);
  const [credits, setCredits] = useState(0);
  const [isActive, setIsActive] = useState(true);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [minimumOrderPrice, setminimumOrderPrice] = useState(0);
  const [creditLimitPerOrder, setCreditLimitPerOrder] = useState(0);
  const [userId, setUserId] = useState();
  const [openCloseConfirmaitonModal, setopenCloseConfirmaitonModal] = useState(false);
  let currentDate = new Date();

  const Restauranttoken = JSON.parse(localStorage.getItem("parentrestaurant"));
  const token = localStorage.getItem("gotasteadmintoken");
  const apiAddress = process.env.REACT_APP_SECRET;

  useEffect(() => {
    const fetchData = async () => {
      if (token) {
        try {
          const decodedData = jwt_decode(token);
          setUserId(decodedData.UserId);
          await axios.get(
            `${apiAddress}/api/RestaurantUserMapper/getbyuseridaAndRestaurantId?userId=${decodedData.UserId}&restaurantId="Restauranttoken.id"`
          ).then((response) => {
            const list = response.data.map((dt) => ({
              id: dt.restaurantId,
              title: dt.restaurantName,
            }));
            setRestaurantDatas(list);
          });
        } catch (error) {
          console.log("Error while fething restaurant list in manage-credits", error);
        }
      }
    }

    fetchData();
  }, []);

  const resetForm = () => {
    setRestaurantAdded([]);
    setCredits(0);
    setFromDate("");
    setToDate("");
    setminimumOrderPrice(0);
    setCreditLimitPerOrder(0);
  };

  const handleSave = async () => {
    if (minimumOrderPrice === 0 || creditLimitPerOrder === 0) {
      toast.error("Provide Minimun Order Price and Credit Limit Per Order Values");
      return;
    }

    if (restaurantAdded.length === 0) {
      toast.error("Please select at least one restaurant");
      return;
    }
    const selectedRestaurantId = restaurantAdded[0]?.id;

    const existingActiveCredits = existingCredits.filter((credit) => {
      return (
        credit.restaurantId.trim().toLowerCase() === selectedRestaurantId.trim().toLowerCase() &&
        new Date(credit.toDate) >= new Date()
      );
    });

    const isOverlapping = existingActiveCredits.some((credit) => {
      const existingToDate = new Date(credit.toDate).setHours(0, 0, 0, 0);
      const newFromDate = new Date(fromDate).setHours(0, 0, 0, 0);
      return newFromDate <= existingToDate;
    });

    if (isOverlapping) {
      toast.error("Cannot add credits before existing ones expire.", { theme: "colored" });
      return;
    }

    const payload = {
      id: "",
      restaurantId: selectedRestaurantId,
      restaurantName: "",
      credits: parseFloat(credits),
      totalGivenCredits: parseFloat(credits),
      isActive: true,
      fromDate,
      toDate,
      minimumOrderPrice: parseFloat(minimumOrderPrice),
      creditLimitPerOrder: parseFloat(creditLimitPerOrder),
      creatorId: userId,
    };

    try {
      const response = await axios.post(
        `${apiAddress}/api/Restaurant/InsertRestaurantCredits`,
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.status === 200 || response.status === 201) {
        toast.success("Restaurant credits added successfully!");
        resetForm();
        onClose();
        window.location.reload(); // Refresh the page
      } else {
        toast.error("Failed to add restaurant credits");
      }
    } catch (error) {
      if (error?.response && error?.response?.data) {
        toast.error(`Error: ${error?.response?.data}`);
      } else {
        toast.error("Error: Unable to save data");
      }
    }
  };

  return (
    <Dialog fullWidth maxWidth="md" open={open} onClose={() => setopenCloseConfirmaitonModal(true)}>
      {/* Confirmation Modal */}
      <SweetAlertModal
        headerText="Do you want to leave without saving?"
        bodyText="All changes made will be lost"
        open={openCloseConfirmaitonModal}
        onyes={() => {
          setopenCloseConfirmaitonModal(false);
          resetForm();
          onClose();
        }}
        close={() => setopenCloseConfirmaitonModal(false)}
        id={2}
      />

      <DialogTitle>
        <Grid container justifyContent="space-between" alignItems="center">
          <span style={{ color: "#2a7fd4" }}>GoTaste - Restaurant Credits</span>
          {/* Close Icon */}
          <IconButton onClick={() => setopenCloseConfirmaitonModal(true)} size="small">
            <CloseIcon />
          </IconButton>
        </Grid>
      </DialogTitle>

      <DialogContent style={{ backgroundColor: "#f3f0f3" }}>
        <Grid container spacing={2} sx={{ paddingTop: "1rem" }}>
          <Grid item xs={4}><Typography>Restaurant</Typography></Grid>
          <Grid item xs={8}>
            {/* <AutoCompleteMultiSelect id={2}  datas={} value={setRestaurantAdded} val={restaurantAdded} /> */}
            <Autocomplete
              id={"2"}
              clearText="clear"
              options={restaurantDatas}
              getOptionLabel={(option) => (
                <>
                  {existingData?.some(res => res?.restaurantId === option?.id && new Date(res?.fromDate) <= currentDate &&
                    new Date(res?.toDate) >= currentDate) ?
                    <div onClick={() => SetOpenEditModal(option?.id)}>
                      {option?.title}
                      <span style={{ color: 'orange', marginLeft: '20px' }}>
                        ⚠️ Eligible credit found!
                      </span>
                    </div>
                    :
                    <>
                      {option?.title}
                    </>
                  }
                </>
              )}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              filterSelectedOptions
              onChange={(event, newInputValue) => {
                setRestaurantAdded(newInputValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Restaurant"
                  required={true}
                />
              )}
              value={restaurantAdded}
              multiple
            />
          </Grid>

          <Grid item xs={4}><Typography>Credits</Typography></Grid>
          <Grid item xs={8}>
            <TextField fullWidth type="number" value={credits} onChange={(e) => setCredits(e.target.value)} />
          </Grid>

          <Grid item xs={4}><Typography>From Date</Typography></Grid>
          <Grid item xs={8}>
            <TextField fullWidth type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
          </Grid>

          <Grid item xs={4}><Typography>To Date</Typography></Grid>
          <Grid item xs={8}>
            <TextField fullWidth type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />
          </Grid>

          <Grid item xs={4}><Typography>Minimum Order Price</Typography></Grid>
          <Grid item xs={8}>
            <TextField fullWidth type="number" value={minimumOrderPrice} onChange={(e) => setminimumOrderPrice(e.target.value)} />
          </Grid>

          <Grid item xs={4}><Typography>Credit Limit Per Order</Typography></Grid>
          <Grid item xs={8}>
            <TextField fullWidth type="number" value={creditLimitPerOrder} onChange={(e) => setCreditLimitPerOrder(e.target.value)} />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleSave} color="primary" variant="contained">
          Save
        </Button>
        <Button onClick={() => setopenCloseConfirmaitonModal(true)} color="secondary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AddRestaurantCreditDialog;
